import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { QuotationDetailCaptureTableModel } from 'src/app/models/tables/preliminaries/quotation-detail-capture-table.model';
import { QuotationDetailSelectionTableModel } from 'src/app/models/tables/preliminaries/quotation-detail-selection-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationDetailService {
  constructor(private _httpClient: HttpClient) { }

  getQuotationDetailsByVersion(quotationVersionId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<QuotationDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('quotationVersionId', quotationVersionId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.get<PagedResponseModel<QuotationDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetQuotationDetailsByVersion}`,
      { params: params }
    );
  }

  getAllCostCenterForSelect(constructionSiteId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetAllCostCenterForSelect}/${constructionSiteId}`);
  }

  getAllUnitsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetAllUnitsForSelect}`);
  }

  getAllBaseValueForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetAllBaseValueForSelect}`);
  }

  getColumnsForQuotationDetailsByVersion(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetColumnsForQuotationDetailsByVersion}`);
  }

  getFirstQuotationDetailByKeysAsync(versionId: number): Observable<QuotationDetailModel> {
    return this._httpClient.get<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetFirstQuotationDetailByKeys}/${versionId}`);
  }

  getLastQuotationDetailByKeysAsync(versionId: number): Observable<QuotationDetailModel> {
    return this._httpClient.get<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetLastQuotationDetailByKeys}/${versionId}`);
  }

  getPreviusQuotationDetailByKeysAsync(versionId: number, quotationDetailId: number | null): Observable<QuotationDetailModel> {
    let params = new HttpParams().set('versionId', versionId)
    if (quotationDetailId !== null)
      params = params.set('quotationDetailId', quotationDetailId.toString());
    return this._httpClient.get<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetPreviusQuotationDetailByKeys}`,
      { params: params });
  }

  getNextQuotationDetailByKeysAsync(versionId: number, quotationDetailId: number | null): Observable<QuotationDetailModel> {
    let params = new HttpParams().set('versionId', versionId)
    if (quotationDetailId !== null)
      params = params.set('quotationDetailId', quotationDetailId.toString());
    return this._httpClient.get<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetNextQuotationDetailByKeys}`,
      { params: params });
  }

  getQuotationDetailById(quotationDetailId: number): Observable<QuotationDetailModel> {
    return this._httpClient.get<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetQuotationDetailById}/${quotationDetailId}`);
  }

  createQuotationDetail(quotationDetailModel: QuotationDetailModel): Observable<QuotationDetailModel> {
    return this._httpClient.post<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.CreateQuotationDetail}`,
      quotationDetailModel);
  }

  updateQuotationDetail(quotationDetailModel: QuotationDetailModel): Observable<QuotationDetailModel> {
    return this._httpClient.put<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.UpdateQuotationDetail}`,
      quotationDetailModel);
  }

  deleteQuotationDetail(quotationDetailId: number): Observable<QuotationDetailModel> {
    return this._httpClient.delete<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.DeleteQuotationDetail}/${quotationDetailId}`);
  }

  deleteSomeDetails(quotationDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.DeleteSomeDetails}`,
      quotationDetailIds);
  }

  getQuotationDetailsByVersionId(quotationVersionId: number): Observable<Array<QuotationDetailModel>> {
    return this._httpClient.get<Array<QuotationDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetQuotationDetailsByVersionId}/${quotationVersionId}`);
  }

  copySolutionFromQuotation(quotationDetails: number[], quotationId: number, quotationVersionId: number): Observable<QuotationDetailModel> {
    return this._httpClient.post<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.CopySolutionFromQuotation}/${quotationId}/${quotationVersionId}`, quotationDetails);
  }

  //Ajuntar Imagenes
  attachImage(quotationDetailId: number, imageNumber: number, file: FormData): Observable<QuotationDetailModel> {
    return this._httpClient.post<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.AttachImages}/${quotationDetailId}/${imageNumber}`,
      file);
  }

  getImageUrl(quotationDetailId: number, fileName: string): Observable<Blob> {
    // if (!fileName) return null;
    return this._httpClient.get(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetImages}/${quotationDetailId}/${encodeURIComponent(fileName)}`,
      { responseType: 'blob' }
    );
  }

  deleteImage(quotationDetailId: number, imageNumber: number): Observable<QuotationDetailModel> {
    return this._httpClient.post<QuotationDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.DeleteImages}/${quotationDetailId}/${imageNumber}`,
      null);
  }

  getQuotationDetailsForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], quotationId: number): Observable<PagedResponseModel<QuotationDetailSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('quotationId', quotationId);
    return this._httpClient.post<PagedResponseModel<QuotationDetailSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetQuotationDetailsForSelectionAsync}`,
      filters, { params: params }
    );
  }

  GetColumnsForQuotationDetailsSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetColumnsForQuotationDetailsSelectionAsync}`);
  }


  getDetailByVersionsForSelectionAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], quotationId: number): Observable<PagedResponseModel<QuotationDetailSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('quotationId', quotationId);
    return this._httpClient.post<PagedResponseModel<QuotationDetailSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetDetailByVersionsForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForDetailByVersionsSelectionAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationDetail.GetColumnsForDetailByVersionsSelectionAsync}`);
  }
}
